<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="chapter" id="title">
<p class="bk">Jesus and the Eyewitnesses</p>
<p class="bk1">The Gospels as Eyewitness Testimony</p>
<p class="bkau">Richard Bauckham</p>
<p class="bkpub">William B. Eerdmans Publishing Company</p>
<p class="bkpub1">Grand Rapids, Michigan / Cambridge, U.K.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-bauckham-0002.vue?fdc8c07e